import { TypePolicies } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';

export default {
  Query: {
    fields: {
      chats: relayStylePagination(['order', 'filter']),
      chatMessages: relayStylePagination(['chatId', 'userId', 'order', 'filter', 'search']),
    },
  },
} satisfies TypePolicies;
